import { faGithub, faInstagram, faLinkedin, faTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';
import GlitchImage from './components/GlitchImage';
import Link from './components/Link';


function App() {

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.substring(1);
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.scrollBy(0, -50)
      }
    };

    // Listen to changes in the URL hash
    window.addEventListener('hashchange', handleHashChange, false);

    // Scroll on initial load if there's a hash
    handleHashChange();

    // Cleanup event listener
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-900 text-white font-sans">
      <div className="flex flex-col items-center w-full max-w-2xl p-4 my-8">

        {/* Profile Section */}
        <div className="flex flex-col items-center w-full max-w-md mb-12 space-y-3">

          <GlitchImage imageUrl={`${process.env.PUBLIC_URL}/avatar.jpg`} />

          <div>
            <h1 className="text-4xl font-serif mb-1 font-bold text-center">longing to it</h1>
            <h2 className="text-base text-center">Works by Francis Szakacs</h2>
          </div>

          <p className="text-gray-400 text-center font-serif">“I heard an owl calling, from the Platt Fields. Real, Vurt, or robo – who can tell the difference any more? No matter. <span className='text-pink-600'>It had a longing to it.</span>” (Jeff Noon, Vurt)</p>

          {/* Social Links */}
          <div className="flex space-x-4 pt-2">
            <a href="https://www.instagram.com/francis_szakacs/" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faInstagram} className="text-2xl" />
            </a>
            <a href="https://www.youtube.com/@szili" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faYoutube} className="text-2xl" />
            </a>
            <a href="https://x.com/francis_systems" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faTwitter} className="text-2xl" />
            </a>
            <a href="https://www.linkedin.com/in/francisszakacs/" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faLinkedin} className="text-2xl" />
            </a>
            <a href="https://github.com/thefranciscook" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faGithub} className="text-2xl" />
            </a>
          </div>

        </div>

        {/* Links Section */}
        <div className="space-y-6 w-full">

          <Link
            anchorLinkId='cobralingusEngine'
            link="https://thefranciscook.github.io/cobralinguseditor/"
            videoFile={`${process.env.PUBLIC_URL}/cobralingus-engine.mp4`}
            imageSrc={`${process.env.PUBLIC_URL}/cobralingus-engine.jpg`}
            category='Art'
            date='Sep 2026'
            repo="https://github.com/thefranciscook/cobralinguseditor"
            title="Cobralingus Engine"
            text="Jeff Noon's Metamorphiction process as an installable web app. Your text becomes a signal and passes through filter gates (DECAY, DRUG, GHOST EDIT, RELEASE VIRUS…), each with its own shader and sound, until the outlet: the ghost haunting the original."
          />

          <Link
            anchorLinkId='robotArm'
            link="https://www.youtube.com/watch?v=2B392ktHd5Q"
            videoSrc="https://www.youtube-nocookie.com/embed/2B392ktHd5Q"
            category='Art'
            date='Nov 2024'
            repo="https://github.com/thefranciscook/lineus-ai"
            title="No matter. It had a longing to it."
            text="An AI which can only respond by drawing with a robot arm. Every answer comes back as pen strokes from a small Line-us drawing machine."
          />

          <Link
            anchorLinkId='nutriMonster'
            link="https://devpost.com/software/nutrimonster"
            videoSrc="https://player.vimeo.com/video/385862807"
            category='Art'
            date='Jan 2020'
            repo="https://github.com/MIT-RH-2/BLANK_32"
            title="NutriMonster"
            text="An augmented reality app that swaps the branding on food packaging for what is actually inside: the Nutri-Score from a distance, full nutrition details up close. Built with Unity, Vuforia and OpenFoodFacts at MIT Reality Hack 2020, where it won Best of Vuforia."
          />

          <Link
            anchorLinkId='f5uck'
            link="https://f5uck.com"
            imageSrc={`${process.env.PUBLIC_URL}/f5uck.jpg`}
            category='Art'
            date='Jan 2026'
            repo="https://github.com/thefranciscook/f5uckcom"
            title="F5UCK"
            text="A five-point severity index for complex systems, from F1 (FUCK) to F5 (FUUUUUCK). It rates how bad things could plausibly get, not how likely they are, and has no positive range: F1 is containment, not optimism."
          />
        </div>

      </div>
    </div>
  );
}

export default App;
